import VideoGenericElement from '$components/GenericElements/VideoGenericElement';
import { GetSharedCandidatesRosterDataOutput } from '$store/modules/candidates';
import { useState /* , MouseEvent */, SyntheticEvent } from 'react';

const SPKCandidateVideos = ({
  videos,
  maxH = 'max-h-40',
}: {
  videos: GetSharedCandidatesRosterDataOutput['candidates'][number]['AdditionalVideos'];
  maxH?: 'max-h-40' | 'max-h-60';
}) => {
  const [videoIndex /* , setVideoIndex */] = useState(0);

  const stopAllVideos = (ev?: SyntheticEvent<HTMLVideoElement>) => {
    const allVideos = document.querySelectorAll(
      `.SPKCandidateVideos video`
    ) as NodeListOf<HTMLVideoElement>;

    allVideos.forEach((singleVideo) => {
      if (!singleVideo.paused && ev && singleVideo !== ev.target) {
        singleVideo.pause();
        singleVideo.currentTime = 0;
      }
    });
  };

  // const handleNextVideo = (ev: MouseEvent<HTMLButtonElement>) => {
  //   ev.stopPropagation();
  //   stopAllVideos();

  //   setVideoIndex((prev) => {
  //     if (prev + 1 >= videos.length) return 0;
  //     return prev + 1;
  //   });
  // };

  return (
    <>
      {videos.map((singleVideo, index) => {
        return (
          <div
            className={`SPKCandidateVideos ${
              index === videoIndex ? 'block' : 'hidden'
            } m-auto`}
            key={`additionalVideo_${singleVideo.Id}`}
          >
            {index === videoIndex && (
              <VideoGenericElement
                videoData={singleVideo}
                className={`w-full object-contain rounded-lg mb-2 ${maxH}`}
                controls
                onPlay={(ev: SyntheticEvent<HTMLVideoElement>) =>
                  stopAllVideos(ev)
                }
              />
            )}
            <div className="text-xs gap-8 flex max-w-full justify-center items-center">
              <span>{singleVideo.Name}</span>
              {/* {videos.length > 1 && (
                <button
                  type="button"
                  className="text-nowrap text-employer-primary font-bold hidden"
                  onClick={handleNextVideo}
                >
                  Next &gt;
                </button>
              )} */}
            </div>
          </div>
        );
      })}
    </>
  );
};

SPKCandidateVideos.defaultProps = {
  maxH: 'max-h-40',
};

export default SPKCandidateVideos;
